import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup, List } from 'semantic-ui-react';

const AppInfo = ({ info, style }) => (
  <div>
    <Popup
      on="click"
      trigger={(
        <Icon
          circular
          size="small"
          name="info"
          className="hover"
          style={{ ...style, color: 'white', backgroundColor: '#50667F' }}
        />)}
    >
      <List bulleted>
        {info.map(text => (
          <List.Item key={text}>{text}</List.Item>
        ))}
      </List>
    </Popup>
  </div>
);

AppInfo.propTypes = {
  info: PropTypes.arrayOf(PropTypes.string).isRequired,
  style: PropTypes.shape({}),
};

AppInfo.defaultProps = {
  style: null,
};

export default AppInfo;



// WEBPACK FOOTER //
// ./src/components/reusable/AppInfo.js